
import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import withWidth from '@material-ui/core/withWidth';
import { withStyles } from '@material-ui/core/styles';
import { Router, Link } from "routes";
import {
  isMobile,
  isBrowser
} from "react-device-detect";
import Icon from '@material-ui/core/Icon';

const styles = () => ({
    forwardIcon: {
      top: 15,
      left: 22,
      color: '#fff',
      position: 'absolute',
      textShadow: '1px 1px 1px #000, -1px -1px 1px #aaa',
      zIndex: 1,
      cursor: 'pointer'
    }
});

class ForwardButton extends React.Component{
    render(){
        const { classes, isServer, url } = this.props;
        return (
           <React.Fragment>
                {
                    isServer ?   
                    <Link to={`/${url.query.category}/${url.query.subCategory}`}>
                        <a className="anchor-link">
                        <Icon className={classes.forwardIcon}>arrow_back_ios</Icon>
                        </a>
                    </Link>
                    :
                    <Icon onClick={() => Router.back()} className={classes.forwardIcon}>arrow_back_ios</Icon>
                }
            </React.Fragment>
        );
        
    }
}


ForwardButton.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default compose(withStyles(styles), withWidth())(ForwardButton);
